import React from 'react'
import Label from "components/general/Label"
import { findArray, RscFromStore } from 'helpers/utils';
import { ColumnRank, ColumnSortOrder, ColumnBib, ColumnName, ColumnNoc, ColumnResult, ColumnQualification, ColumnRecords, ColumnWarnings } from "components/common/TableColumns"
import SportCode from 'components/common/SportCode'
import { getRscObject } from 'helpers/rsc';

export function TableColumnsSummary() {
    return (
        [
            ColumnRank({}),
            ColumnLane({}),
            ColumnBib({}),
            ColumnNoc({ disableSort: true }),
            ColumnName({ disableSort: true }),
            ColumnWarnings({ disableSort: true }),
            ColumnHeat({ disableSort: true }),
            ColumnPosition({}),
            ColumnResult({ disableSort: true }),
            ColumnRule({ disableSort: true, label: '' }),
            ColumnRecords({ disableSort: true, label: '' }),
            ColumnQualification({ disableSort: true })

        ]
    )
}

export function TableColumnsSummarySM() {

    return (
        [
            ColumnRank({ disableSort: true }),
            ColumnNoc({ disableSort: true }),
            ColumnName({ disableSort: true }),
            ColumnWarnings({ disableSort: true }),
            ColumnResult({ disableSort: true }),
            ColumnRule({ disableSort: true, label: '' }),
            ColumnRecords({ disableSort: true, label: '' }),
            ColumnQualification({ disableSort: true })
        ]
    )
}

export function TableColumnsSummaryWithoutSB() {
    return (
        [
            ColumnRank({}),
            ColumnBib({}),
            ColumnNoc({ disableSort: true }),
            ColumnName({ disableSort: true }),
            ColumnWarnings({ disableSort: true }),
            ColumnHeat({ disableSort: true }),
            ColumnPosition({}),
            ColumnResult({ disableSort: true }),
            ColumnRule({ disableSort: true, label: '' }),
            ColumnRecords({ disableSort: true, label: '' }),
            ColumnQualification({ disableSort: true })

        ]
    )
}

export function TableColumnsSummaryWithoutSBSM() {

    return (
        [
            ColumnRank({ disableSort: true }),
            ColumnNoc({ disableSort: true }),
            ColumnName({ disableSort: true }),
            ColumnWarnings({ disableSort: true }),
            ColumnResult({ disableSort: true }),
            ColumnRule({ disableSort: true, label: '' }),
            ColumnRecords({ disableSort: true, label: '' }),
            ColumnQualification({ disableSort: true })
        ]
    )
}

export function TableColumnsSummaryRelay() {
    return (
        [
            ColumnRank({}),
            ColumnNoc({ disableSort: true }),
            ColumnName({ disableSort: true }),
            ColumnWarnings({ disableSort: true }),
            ColumnHeat({ disableSort: true }),
            ColumnPosition({}),
            ColumnResult({ disableSort: true }),
            ColumnRecords({ disableSort: true, label: '' }),
            ColumnQualification({ disableSort: true })

        ]
    )
}

export function TableColumnsSummaryRelaySM() {

    return (
        [
            ColumnRank({ disableSort: true }),
            ColumnNoc({ disableSort: true }),
            ColumnName({ disableSort: true }),
            ColumnWarnings({ disableSort: true }),
            ColumnResult({ disableSort: true }),
            ColumnRecords({ disableSort: true, label: '' }),
            ColumnQualification({ disableSort: true })
        ]
    )
}

export function TableColumnsSummaryFC() {
    return (
        [
            ColumnRank({}),
            ColumnBib({}),
            ColumnNoc({ disableSort: true }),
            ColumnName({ disableSort: true }),
            ColumnWarnings({ disableSort: true }),
            ColumnHeat({ disableSort: true, label: 'LabelGroup' }),
            ColumnPosition({}),
            ColumnResultFC({ disableSort: true }),
            ColumnRule({ disableSort: true, label: '' }),
            ColumnRecords({ disableSort: true, label: '' }),
            ColumnQualification({ disableSort: true })

        ]
    )
}

export function TableColumnsSummaryFCSM() {

    return (
        [
            ColumnRank({ disableSort: true }),
            ColumnNoc({ disableSort: true }),
            ColumnName({ disableSort: true }),
            ColumnWarnings({ disableSort: true }),
            ColumnHeatFCSM({ disableSort: true, label: 'LabelGroup' }),
            ColumnResultFC({ disableSort: true }),
            ColumnRule({ disableSort: true, label: '' }),
            ColumnRecords({ disableSort: true, label: '' }),
            ColumnQualification({ disableSort: true })
        ]
    )
}

function getResultFC(result, wind) {
    return (
        <><div>{result}</div> <div className="fst-italic">{wind}</div></>
    )
}

export function ColumnResultFC({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-10 ',
    label = 'HeaderResult',
    remove = false,
    hideIrm = false
}) {
    return (
        {
            Header: <Label data={label} />,
            accessor: (props) => { return props.sortOrder },
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            id: 'Result',
            remove: remove,

            Cell: (props) => {
                let rsc = RscFromStore()
                let discipline = getRscObject(rsc).discipline
                let rowNumberIrm = findArray(props.cell.row.original.extendedResults, { er_code: ['IRM_LAP'] })
                let numberIrm = rowNumberIrm?.er_value || ''
                let resultIrm = (props.cell.row.original.resultIrm)

                let irmObject = {}
                switch (resultIrm) {
                    case 'DNF':
                        irmObject = <><SportCode discipline={discipline} entity='@IRM' code={resultIrm} abbr={true} isAddLegend={true} />{numberIrm}</>
                        break;
                    case 'LAP':
                        irmObject = <>{numberIrm}<SportCode discipline={discipline} entity='@IRM' code={resultIrm} abbr={true} isAddLegend={true} /></>
                        break;
                    default:
                        irmObject = <SportCode discipline={discipline} entity='@IRM' code={resultIrm} abbr={true} isAddLegend={true} related={resultIrm} />
                        break;
                }
                irmObject = hideIrm ? <></> : irmObject;
                let windSpeed = findArray(props.cell.row.original?.extendedResults, { er_code: ['WIND_SPEED'] })?.er_value
                return (
                    props.cell.row.original.resultType === 'IRM'
                        ? irmObject
                        : windSpeed ? getResultFC(props.cell.row.original.resultData, windSpeed) : props.cell.row.original.resultData
                )
            },
        }
    )
}

export function ColumnRule({
    disableSort = false,
    className = 'text-end',
    headerClassName = 'text-end w-5 text-nowrap',
    label = 'HeaderRule'
    //if (!value) hiddenColumns.push('ColumnRule')
}) {
    return (
        {
            Header: <Label data={label} />,
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'Rule',
            Cell: (props) => {
                //let value = findArray(props.cell.row.original.extendedResults,{ er_code: ['MS'] }).er_value
                let rule = props.cell.row.original.extendedResults.filter(row => (row.er_code === 'RULE')).map((val) => { return (val.er_value) });
                let tie = props.cell.row.original.extendedResults.filter(row => (row.er_code === 'MS')).map((val) => { return (val.er_value) });
                let resp = rule.length > 0 ? rule : tie.length > 0 ? '(' + tie + ')' : ''
                return (resp)
            }
        }
    )
}

export function ColumnLane({
    disableSort = false,
    className = 'text-end',
    headerClassName = 'text-end w-5 text-nowrap',
    label = 'HeaderLane'
}) {
    return (
        {
            Header: <Label data={label} />,
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'Lane',
            Cell: (props) => {
                let value = findArray(props.cell.row.original.extendedResults, { er_code: ['UNIT_LANE'] }).er_value
                return value
            }
        }
    )
}

export function ColumnHeatFCSM({
    disableSort = false,
    className = 'text-end',
    headerClassName = 'text-end w-5 text-nowrap',
    label = 'HeaderHeat'
}) {
    return (
        {
            Header: <Label data={label} />,
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'Heat',
            Cell: (props) => {
                let group = findArray(props.cell.row.original.extendedResults, { er_code: ['UNIT_NUM'] }).er_value
                let position = findArray(props.cell.row.original.extendedResults, { er_code: ['UNIT_RANK'] })?.er_value
                return group + ' (' + position + ')'
            }
        }
    )
}

export function ColumnHeat({
    disableSort = false,
    className = 'text-end',
    headerClassName = 'text-end w-5 text-nowrap',
    label = 'HeaderHeat'
}) {
    return (
        {
            Header: <Label data={label} />,
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'Heat',
            Cell: (props) => {
                let value = findArray(props.cell.row.original.extendedResults, { er_code: ['UNIT_NUM'] }).er_value
                return value
            }
        }
    )
}

export function ColumnPosition({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-5 text-nowrap',
    label = 'HeaderPosition'
}) {
    return (
        {
            Header: <Label data={label} />,
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'Position',
            accessor: (props) => {
                let value = findArray(props.extendedResults, { er_code: ['UNIT_RANK'] })?.er_value
                return value
            }
        }
    )
}



